import { StaticImage } from 'gatsby-plugin-image';
import React, { FC } from 'react';

import AppDownloadQR from '../AppDownloadQR';

export type GetStartedBannerType = 'get-started' | 'start-sharing' | 'get-started-welcome';

interface Props {
  className?: string;
  type: GetStartedBannerType;
}

export const GetStartedBanner: FC<Props> = ({ className, type = 'get-started' }) => {
  const renderImage = () => {
    switch (type) {
      case 'start-sharing':
        return (
          <div className="md:absolute bottom-0">
            <StaticImage
              height={500}
              quality={100}
              src="./assets/start-sharing.png"
              alt="Start sharing the care with others in the CircleOf App"
            />
          </div>
        );
      case 'get-started-welcome':
      case 'get-started':
        return (
          <div className="md:absolute bottom-0">
            <StaticImage height={500} quality={100} src="./assets/phone.png" alt="Care starts with you. Create your circle." />
          </div>
        );
    }
  };

  const renderTitle = () => {
    switch (type) {
      case 'start-sharing':
        return (
          <>
            Start sharing the care with <br /> others in the CircleOf App
          </>
        );
      case 'get-started-welcome':
        return (
          <>
            Welcome Families
            <br />
            into Your ‘CircleOf’ Care
          </>
        );
      case 'get-started':
        return (
          <>
            Care starts with you. <br />
            Create your circle.
          </>
        );
    }
    return '';
  };

  return (
    <div
      id="get-started-banner"
      className={className}
      style={{ backgroundColor: 'rgba(208, 235, 235, 0.5)', borderTopLeftRadius: 40, borderTopRightRadius: 40 }}
    >
      <div className="container mx-auto">
        <div className="relative flex flex-col md:flex-row items-center justify-center md:-mx-8">
          <div className="md:w-6/12 lg:w-4/12 md:px-8 flex justify-end" style={{ marginLeft: '-15%' }}>
            {renderImage()}
          </div>
          <div className="md:w-6/12 px-8 mt-14 mb-10 flex flex-col">
            <h4 className="text-4xl xl:text-5xl mb-6 mt-0 text-center md:text-left">{renderTitle()}</h4>

            <AppDownloadQR />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStartedBanner;
